import {
  array,
  boolean,
  exactOptional,
  literal,
  object,
  picklist,
  pipe,
  string,
  transform,
  type InferInput,
  type InferOutput,
} from "valibot";
import { compoundKey } from "@supply25/database/key";

export const MessageVersionSchema = object({
  text: string(),
  date: string(),
});

const messageEntries = {
  type: literal("REASSESSMENT_MESSAGE"),
  text: string(),
  authorId: string(),
  authorName: string(),
  organisationId: string(),
  workspaceId: string(),
  party: picklist(["BUYER", "SUPPLIER"]),
  createdDate: string(),
  lastUpdated: string(),
  edited: exactOptional(boolean()),
  deleted: exactOptional(boolean()),
};

export const ReassessmentMessageDbSchema = object({
  ...messageEntries,
  versions: exactOptional(array(MessageVersionSchema)),
  pk: compoundKey("CONTRACT", "URLID"),
  sk: compoundKey("QUESTION", "MESSAGE"),
});

export type ReassessmentMessageDb = InferOutput<
  typeof ReassessmentMessageDbSchema
>;

export const ReassessmentMessageOutSchema = object({
  ...messageEntries,
  id: string(),
  questionId: string(),
});

export const ReassessmentMessageSchema = pipe(
  ReassessmentMessageDbSchema,
  transform(
    ({ pk, sk, versions, ...rest }) =>
      ({
        ...rest,
        text: rest.deleted ? "" : rest.text,
        id: sk.MESSAGE,
        questionId: sk.QUESTION,
      }) satisfies InferInput<typeof ReassessmentMessageOutSchema>,
  ),
);

export type ReassessmentMessage = InferOutput<
  typeof ReassessmentMessageOutSchema
>;

export const reassessmentMessageKey = {
  pk: ReassessmentMessageDbSchema.entries.pk,
  sk: ReassessmentMessageDbSchema.entries.sk,
};
